// extracted by mini-css-extract-plugin
export var banner = "_1h-0";
export var icon = "_1h-1";
export var message = "_1h-2";